import { Link as RouterLink, LinkProps as RouterLinkProps } from "react-router-dom";

import { default as MuiLink } from "@mui/material/Link";

const Link: React.FC<RouterLinkProps> = ({ to, ...props }) => (
  <MuiLink component={RouterLink} underline="none" display="inline-flex" to={to} {...props} />
);

export default Link;
